export type AppMode = 'internal' | 'agent';

export const INTERNAL_APP_MODE: AppMode = 'internal';
export const AGENT_APP_MODE: AppMode = 'agent';
export const AGENCY_BASE_PATH = '/agency';
export const INTERNAL_CRM_HOSTNAMES = [
  'crm.level.travel',
  'crm-alpha.level.travel',
  'crm-beta.level.travel',
  'crm-gamma.level.travel',
  'crm-delta.level.travel',
];

export const isAgencyPath = (pathname: string): boolean =>
  pathname === AGENCY_BASE_PATH || pathname.startsWith(`${AGENCY_BASE_PATH}/`);

export const getAppBasePath = (): string =>
  typeof window !== 'undefined' && isAgencyPath(window.location.pathname)
    ? AGENCY_BASE_PATH
    : '';

export const withAppBasePath = (pathname: string): string => {
  const basePath = getAppBasePath();

  if (!basePath || isAgencyPath(pathname)) return pathname;

  return `${basePath}${pathname.startsWith('/') ? pathname : `/${pathname}`}`;
};

export const resolveAppMode = (hostname: string): AppMode =>
  INTERNAL_CRM_HOSTNAMES.includes(hostname.trim().toLowerCase())
    ? INTERNAL_APP_MODE
    : AGENT_APP_MODE;

export const getCurrentAppMode = (): AppMode =>
  resolveAppMode(typeof window === 'undefined' ? '' : window.location.hostname);
